/* Persist existing GA identifiers to Shopify orders; never invent a visitor ID. */
(() => {
  if (window.__bsaiIdentityCaptureV1) return;
  window.__bsaiIdentityCaptureV1 = true;
  const stream = 'JEXR4X368Y';
  let busy = false;
  let requested = false;
  let last = '';
  const cookie = name => {
    const prefix = encodeURIComponent(name) + '=';
    const row = document.cookie.split(';').map(x => x.trim()).find(x => x.startsWith(prefix));
    if (!row) return '';
    try { return decodeURIComponent(row.slice(prefix.length)); } catch { return ''; }
  };
  async function persist() {
    if (busy) { requested = true; return; }
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    const allowed = privacy.analyticsProcessingAllowed() === true;
    const ga = allowed ? cookie('_ga').match(/^GA\d+\.\d+\.(\d+\.\d+)$/) : null;
    const sessionCookie = allowed ? cookie('_ga_' + stream) : '';
    const session = sessionCookie.match(/^GS1\.\d+\.(\d+)\./)?.[1] || sessionCookie.match(/^GS2\.\d+\.s(\d+)(?:\$|$)/)?.[1] || '';
    const attributes = {
      __ga_client_id: ga?.[1] || '',
      __ga_session_id: session,
      __tracking_analytics_allowed: allowed ? 'granted' : 'denied'
    };
    busy = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(root + 'cart.js', {credentials:'same-origin'});
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const signature = JSON.stringify([cart.token, attributes]);
      if (signature === last) return;
      if (privacy.analyticsProcessingAllowed() !== allowed) { requested = true; return; }
      const response = await fetch(root + 'cart/update.js', {
        method:'POST', credentials:'same-origin', keepalive:true,
        headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes})
      });
      if (response.ok) last = signature;
    } catch { /* Capture cannot prevent shopping or checkout. */ }
    finally { busy = false; if (requested) { requested = false; persist(); } }
  }
  const start = () => { persist(); [500,2000,5000,15000].forEach(ms => setTimeout(persist,ms)); };
  document.addEventListener('visitorConsentCollected', () => { last=''; start(); });
  document.addEventListener('cart:updated', () => { last=''; persist(); });
  window.addEventListener('pageshow', start);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) persist(); });
  if (window.Shopify?.customerPrivacy) start();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error => { if (!error) start(); });
})();
